import { render, staticRenderFns } from "./CustomerGroups.vue?vue&type=template&id=7bb6cf09&"
import script from "./CustomerGroups.vue?vue&type=script&lang=js&"
export * from "./CustomerGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports